import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { isBaseQueryParams } from "@/helpers/isBaseQueryParams";
import { getUsers } from "./api";
import { QueryParamsBase } from "@/types/types";

const STALE_TIME_BASE = 1000 * 60 * 10; // 10 minutos

export function useUsers(
  params?: QueryParamsBase,
  select?: string[],
  options?: object,
) {
  const isBaseQuery = isBaseQueryParams(params);

  const paramsQuery = isBaseQuery ? { current: params?.current, pageSize: params?.pagination?.pageSize } : params;

  const query = useQuery({
    queryKey: ["users", { params: paramsQuery, select }],
    queryFn: () => getUsers({ ...paramsQuery, select }),
    staleTime: isBaseQuery ? STALE_TIME_BASE : 0,
    gcTime: isBaseQuery ? STALE_TIME_BASE : 0,
    placeholderData: keepPreviousData,
    ...options,
  });

  return { ...query };
}


